// ============================================================================
// useGoogleMap.ts — Thin lifecycle hook for Google Maps cleanup and theme
// ============================================================================

import { useEffect } from 'react';
import {
    clearMapRefresh,
    mapCleanup,
    CurrentMap,
} from '@/services/map-service';
import {
    MIDNIGHT_MAP_STYLE,
    GOOGLE_NIGHT_MAP_STYLE,
    TEMP_MAP_STYLE,
} from '@/constants/map-styles';

export function useGoogleMap() {
    // Cleanup on unmount
    useEffect(() => {
        return () => {
            clearMapRefresh();
            mapCleanup();
        };
    }, []);

    // Theme change listener
    useEffect(() => {
        const handleThemeChange = (event: any) => {
            if (CurrentMap && CurrentMap.map) {
                let mapStyle: any;
                if (event.detail.theme === 'theme-blue-dark') {
                    mapStyle = MIDNIGHT_MAP_STYLE;
                } else if (event.detail.theme === 'theme-gray-dark') {
                    mapStyle = GOOGLE_NIGHT_MAP_STYLE;
                } else {
                    mapStyle = TEMP_MAP_STYLE;
                }
                CurrentMap.map.setOptions({ styles: mapStyle });
            }
        };

        window.addEventListener('vue2-theme-change', handleThemeChange);
        return () => {
            window.removeEventListener('vue2-theme-change', handleThemeChange);
        };
    }, []);

    return { CurrentMap };
}
